<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-12'
    ]"
    alt="Fpx logo"
    src="@/assets/image/fpx-logo.svg"
  />
</template>